import React from 'react';

import { TextField, PrimaryButton, SecondaryButton } from '../Ui';
import Form from '../utils/Form';

import RadioButton from '../common/components/form/RadioButton';
import Tooltip from '../common/components/form/Tooltip';
import Switch from '../common/components/form/Switch';

function ProjectForm({
  headerText,
  submitButtonText,
  fields,
  loading,
  handleTextFieldChange,
  handleDateFieldBlur,
  handleRadioButtonChange,
  handleSwitchChange,
  handleSubmit,
  handleCancel
}) {
  return (
    <div className="c-project-form a-slide">
      <header className="c-project-form__header">{headerText}</header>
      <Form onSubmit={handleSubmit}>
        <main>
          <header className="c-project-form__section-header">
            Informations générales
          </header>
          {/* Row */}
          <div className="c-project-form__section">
            <div className="u-flex">
              <div className="c-project-form__field c-project-form__field--margin">
                <TextField
                  value={fields.name}
                  label="Nom du projet *"
                  onChange={handleTextFieldChange.bind(null, 'name')}
                />
              </div>
              <div className="c-project-form__field">
                <TextField
                  value={fields.city}
                  label="Ville *"
                  onChange={handleTextFieldChange.bind(null, 'city')}
                />
              </div>
            </div>
            {/* Row */}
            <div className="u-flex">
              <div className="c-project-form__field c-project-form__field--margin">
                <TextField
                  label="Date de fin de chantier"
                  placeholder="JJ/MM/AAAA"
                  value={fields.date_of_receipt}
                  onChange={handleDateFieldBlur}
                />
              </div>
              <div className="c-project-form__field">
                <TextField
                  value={fields.email}
                  label="Email *"
                  onChange={handleTextFieldChange.bind(null, 'email')}
                />
              </div>
            </div>
            {/* Row */}
            <div className="c-project-form__field">
              <TextField
                value={fields.comment}
                label="Commentaire"
                onChange={handleTextFieldChange.bind(null, 'comment')}
              />
            </div>
          </div>
          <header className="c-project-form__section-header">
            Choix de la finition des cylindres
          </header>
          {/* Row */}
          <div
            className="u-flex u-flex--justify-around u-flex--align-items-center"
            style={{ padding: '10px 30px' }}
          >
            <div
              onClick={handleRadioButtonChange.bind(
                null,
                'surface_treatment_code',
                'LN'
              )}
            >
              <div className="c-project-form__cylinder">
                <img
                  className="radio-block__img"
                  src={require('../../assets/cylindre-laiton-nickele.jpg')}
                />
              </div>
              <div>
                <RadioButton
                  name="finition"
                  value="LN"
                  checked={fields.surface_treatment_code === 'LN'}
                  onChange={handleRadioButtonChange.bind(
                    null,
                    'surface_treatment_code'
                  )}
                />
                <label className="c-project-form__radio-label">
                  Laiton nickelé
                </label>
                <Tooltip>
                  Depuis l’avènement de la menuiserie aluminium et PVC, une finition dite « nickelée » est de plus en plus répandue.
                  <br />
                  Le nickel améliore les propriétés anti-oxydantes et anticorrosives du laiton tout en lui conférant un aspect gris.
                </Tooltip>
              </div>
            </div>
            <div className="c-project-form__separator" />
            <div
              onClick={handleRadioButtonChange.bind(
                null,
                'surface_treatment_code',
                'LP'
              )}
            >
              <div>
                <img
                  className="radio-block__img"
                  src={require('../../assets/cylindre-laiton-poli.jpg')}
                />
              </div>
              <div>
                <RadioButton
                  name="finition"
                  value="LP"
                  checked={fields.surface_treatment_code === 'LP'}
                  onChange={handleRadioButtonChange.bind(
                    null,
                    'surface_treatment_code'
                  )}
                />
                <label className="c-project-form__radio-label">
                  Laiton poli
                </label>
                <Tooltip>
                  La finition poli donne un aspect jaune qui terni dans le temps sans altérer ses qualités de fonctionnement.
                </Tooltip>
              </div>
            </div>
          </div>
          <header className="c-project-form__section-header hide">
            Options avancées
          </header>
          {/* Row */}
          <div className="c-project-form__options-block u-flex hide">
            <div className="u-flex-1">
              <span>Clés protégées</span>
              <Tooltip top right>
                Les clés peuvent être protégées contre toute reproduction illicite.
                <br />
                Seule l'usine d'origine est habilitée à les reproduire sur présentation d’une carte de propriété.
                <br />
                Il existe 2 types de protection : <br />
                - la protection par brevet, limitée à un nombre d’années<br />
                - la protection par dépôt de marque (copyright) qui protège la clé à vie.
              </Tooltip>
              <Switch
                checked={fields.is_protected}
                onChange={handleSwitchChange.bind(this, 'is_protected')}
              />
            </div>
            <div className="u-flex-1">
              <span>Seulement A2P</span>
              <Tooltip top left>
                La certification A2P (Assurance Prévention Protection) 1, 2 ou 3 étoiles offre des capacités supplémentaires de résistance aux tentatives d’effraction.
                <br />
                Elle est souvent préconisée dans les logements.<br />
                Un cylindre A2P doit être obligatoirement être associé à une serrure de même marque et de même niveau.
                <br />
                Cette certification émane d’une démarche volontaire délivrée par un organisme indépendant et est reconnue par les assureurs.
              </Tooltip>
              <Switch
                checked={fields.a2p}
                onChange={handleSwitchChange.bind(this, 'a2p')}
              />
            </div>
          </div>
        </main>
        {/* Footer */}
        <footer className="c-project-form__footer c-project-form__section u-text-right">
          <span className="c-project-form__cancel">
            <SecondaryButton onClick={handleCancel}>

              Annuler
            </SecondaryButton>
          </span>
          <PrimaryButton loading={loading} submit>

            {submitButtonText}
          </PrimaryButton>
        </footer>
      </Form>
    </div>
  );
}

export default ProjectForm;



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectForm.js